module.exports = __webpack_public_path__ + "img/eshop.b6659cba.jpg";